export var SEPARATOR = ', ';
export var MAX_LIST_HEIGHT = 135;